import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { toMilliseconds } from '@fretadao/f-js-utils';

application.register('support-chat', class extends Controller {
  static values = {
    email: String,
    name: String,
    phone: String,
    toggle: { type: Boolean, default: false }
  }

  connect() {
    setTimeout(() => { this.initializeChat() }, toMilliseconds(0.5, 'seconds'));
  }

  initializeChat() {
    this.setupChat(document, this.emailValue, this.nameValue)
      .then(() => {
        setTimeout(() => {
          zE('messenger:set', 'locale', 'pt-BR');
          if (this.tagsValue) zE('messenger:set', 'conversationTags', String(this.tagsValue).split(','));
          if (this.toggleValue) zE('messenger', 'open');
        }, 500);
      })
  }

  openChat() {
    zE('messenger', 'open');
  }

  async setupChat(doc, email, name) {
    return new Promise((resolve, reject) => {
      let js = document.createElement('script');
      js.type = 'text/javascript';
      js.async = 1;
      js.src = 'https://static.zdassets.com/ekr/snippet.js?key=d7c21c5f-642e-4137-ba46-a3888c984cee';
      js.id = 'ze-snippet';
      doc.body.appendChild(js);

      js.onload = resolve;
      js.onerror = reject;
    });
  }
});
